var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-calendar-arrow-down-icon lucide-calendar-arrow-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 18 4 4 4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10h18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrowDown);
export default __webpack_public_path__ + "static/media/calendar-arrow-down.3fc8c84b28c3e002608b309f75ee7b8b.svg";
export { ForwardRef as ReactComponent };